import user from "../assets/images/pages/dashboard/info-counter-icons/user-svgrepo-com.svg";

const counter_icons = [
  {
    id: 0,
    icon: user,
  },
  {
    id: 1,
    icon: user,
  },
  {
    id: 2,
    icon: user,
  },
  {
    id: 3,
    icon: user,
  },
];

export default counter_icons;
